/*
 *
 * WishList actions
 *
 */

const SCOPE = 'app/WishList/';
export const ActionTypes = {
    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    RESET_PAGE: `${SCOPE}RESET_PAGE`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,
    SET_AUTH_LOADING: `${SCOPE}SET_AUTH_LOADING`,
    /**
     * UserImages
     */
    SET_USER_IMAGES_IS_LOADED: `${SCOPE}SET_USER_IMAGES_IS_LOADED`,
    FETCH_USER_IMAGES_STARTED: `${SCOPE}FETCH_USER_IMAGES_STARTED`,
    FETCH_USER_IMAGES_SUCCESSFULLY: `${SCOPE}FETCH_USER_IMAGES_SUCCESSFULLY`,
    FETCH_USER_IMAGES_FAILED: `${SCOPE}FETCH_USER_IMAGES_FAILED`,
    FETCH_USER_IMAGES_CANCELLED: `${SCOPE}FETCH_USER_IMAGES_CANCELLED`,
};

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const resetPage = () => ({ type: ActionTypes.RESET_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});
export const setAuthLoading = (isLoading) => {
    return { type: ActionTypes.SET_AUTH_LOADING, isLoading };
};

/**
 * UserImages
 */
export const setUserImagesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_USER_IMAGES_IS_LOADED,
    isLoaded,
});
export const fetchUserImagesStarted = () => ({ type: ActionTypes.FETCH_USER_IMAGES_STARTED });
export const fetchUserImagesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY,
    res,
});
export const fetchUserImagesFailed = (error) => ({
    type: ActionTypes.FETCH_USER_IMAGES_FAILED,
    error,
});
export const fetchUserImagesCancelled = () => ({
    type: ActionTypes.FETCH_USER_IMAGES_CANCELLED,
});
